import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SuperadminComponent } from './superadmin.component';
import { ChannelPartnerComponent } from './master/channelpartner/channelpartner.component';
import { SchoolComponent } from './master/school/school.component';
import { BranchComponent } from './master/branch/branch.component';
import { ClassgroupComponent } from './master/classgroup/classgroup.component';
import { ClassComponent } from './master/class/class.component';
import { SectionComponent } from './master/section/section.component';
import { CountryComponent } from './master/country/country.component';
import { StateComponent } from './master/state/state.component';
import { CityComponent } from './master/city/city.component';
import { SuperPageSetUpComponent } from './admin/superpagesetup/superpagesetup.component';
import { PackageComponent } from './subscription/package/package.component';
import { FeatureComponent } from './subscription/feature/feature.component';
import { PackageSiteMapComponent } from './subscription/packagesitemap/packagesitemap.component';
import { SubscriptionComponent } from './subscription/subscription/subscription.component';
import { MobilepackagesitemapComponent } from './subscription/mobilepackagesitemap/mobilepackagesitemap.component';
import { SmsapiComponent } from './sms/smsapi/smsapi.component';
import { TransactionalaccountComponent } from './sms/transactionalaccount/transactionalaccount.component';
import { PromotionalAccountComponent } from './sms/promotional-account/promotional-account.component';
import { WebsiteComponent } from './cms/website/website.component';
import { SliderComponent } from './cms/slider/slider.component';
import { SiteMapComponent } from './cms/site-map/site-map.component';
import { AccountSiteMapComponent } from './cms/account-site-map/account-site-map.component';
import { TemplateComponent } from './template/template/template.component';
import { TemplateBranchMapComponent } from './template/template-branch-map/template-branch-map.component';
import { AdsSliderComponent } from './ads/ads-slider/ads-slider.component';
import { SessionComponent } from './master/session/session.component';
import { PackagematrixComponent } from './subscription/packagematrix/packagematrix.component';
import { PackagesaleComponent } from './subscription/packagesale/packagesale.component';
import { PackagepriceComponent } from './subscription/packageprice/packageprice.component';
import { MediaFileComponent } from './resource/media-file/media-file.component';
import { KnowledgeBaseComponent } from './resource/knowledge-base/knowledge-base.component';
import { KnowledgeBaseSearchComponent } from './resource/knowledge-base-search/knowledge-base-search.component';
import { BlogCategoryComponent } from './resource/blog-category/blog-category.component';
import { BlogPostComponent } from './resource/blog-post/blog-post.component';
import { BlogPostSearchComponent } from './resource/blog-post-search/blog-post-search.component';
import { SuperdashboardComponent } from './dashboard/superdashboard/superdashboard.component';
import { OrganizationComponent } from './admin/organization/organization.component';
import { JosaUrlComponent } from './cms/josa-url/josa-url.component';
import { CurrencyComponent } from './subscription/currency/currency.component';
import { PackageGroupCountryComponent } from './subscription/package-group-country/package-group-country.component';


const routes: Routes = [
  {
  path: '',
  component: SuperadminComponent,
  children: [
     { path: 'dashboard', component: SuperdashboardComponent, pathMatch: 'full' },
     { path: 'channelpartner', component: ChannelPartnerComponent, pathMatch: 'full' },
     { path: 'school', component: SchoolComponent, pathMatch: 'full' },
     { path: 'branch', component: BranchComponent, pathMatch: 'full' },
     { path: 'session', component: SessionComponent, pathMatch: 'full' },
     { path: 'classgroup', component: ClassgroupComponent, pathMatch: 'full' },
     { path: 'class', component: ClassComponent, pathMatch: 'full' },
     { path: 'section', component: SectionComponent, pathMatch: 'full' },
     { path: 'country', component: CountryComponent, pathMatch: 'full' },
     { path: 'state', component: StateComponent, pathMatch: 'full' },
     { path: 'city', component: CityComponent, pathMatch: 'full' },
     { path: 'superpagesetup', component: SuperPageSetUpComponent, pathMatch: 'full' },
     { path: 'currency', component: CurrencyComponent, pathMatch: 'full' },
     { path: 'package', component: PackageComponent, pathMatch: 'full' },
     { path: 'packagefeature', component: FeatureComponent, pathMatch: 'full' },
     { path: 'packagematrix', component: PackagematrixComponent, pathMatch: 'full' },
     { path: 'packagesale', component: PackagesaleComponent, pathMatch: 'full' },
     { path: 'packageprice', component: PackagepriceComponent, pathMatch: 'full' },
     { path: 'packagesitemap', component: PackageSiteMapComponent, pathMatch: 'full' },
     { path: 'subscription', component: SubscriptionComponent, pathMatch: 'full' },
     { path: 'mobilepackagesitemap', component: MobilepackagesitemapComponent, pathMatch: 'full' },
     { path: 'smsapi', component: SmsapiComponent, pathMatch: 'full' },
     { path: 'transactionalaccount', component: TransactionalaccountComponent, pathMatch: 'full' },
     { path: 'promotionalaccount', component: PromotionalAccountComponent, pathMatch: 'full' },
     { path: 'website', component: WebsiteComponent, pathMatch: 'full' },
     { path: 'slider', component: SliderComponent, pathMatch: 'full' },
     { path: 'sitemap', component: SiteMapComponent, pathMatch: 'full' },
     { path: 'josa-url', component: JosaUrlComponent, pathMatch: 'full' },
     { path: 'accountsitemap', component: AccountSiteMapComponent, pathMatch: 'full' },
     { path: 'template', component: TemplateComponent, pathMatch: 'full' },
     { path: 'templatebranchmap', component: TemplateBranchMapComponent, pathMatch: 'full' },
     { path: 'adsslider', component: AdsSliderComponent, pathMatch: 'full' },
     { path: 'media-file', component: MediaFileComponent, pathMatch: 'full' },
     { path: 'knowledge-base', component: KnowledgeBaseComponent, pathMatch: 'full' },
     { path: 'knowledge-base-search', component: KnowledgeBaseSearchComponent, pathMatch: 'full' },
     { path: 'blog-category', component: BlogCategoryComponent, pathMatch: 'full' },
     { path: 'blog-post', component: BlogPostComponent, pathMatch: 'full' },
     { path: 'blog-post-search', component: BlogPostSearchComponent, pathMatch: 'full' },
     { path: 'organization', component: OrganizationComponent, pathMatch: 'full' },
     { path: 'package-group-country', component: PackageGroupCountryComponent, pathMatch: 'full' },
     
  ]
  }

  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuperadminRoutingModule { }
